import { render, staticRenderFns } from "./TemplatesNotExists.vue?vue&type=template&id=1a82d9e0&scoped=true&"
import script from "./TemplatesNotExists.vue?vue&type=script&lang=ts&"
export * from "./TemplatesNotExists.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesNotExists.vue?vue&type=style&index=0&id=1a82d9e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82d9e0",
  null
  
)

export default component.exports